import type { CatalogTree } from '../types';

export const shoppers = {
  none: '—',
  alwaysStaff: 'Her zaman personel',
  list: {
    label: 'Müşteriler',
    search: 'Ara',
    channel: 'Kanal',
    tag: 'Etiket',
    allChannels: 'Tüm kanallar',
    allTags: 'Tüm etiketler',
    filters: 'Filtreler',
    column: {
      shopper: 'Müşteri',
      handle: 'Telefon / kullanıcı adı',
      channels: 'Kanallar',
      lastContact: 'Son iletişim',
      conversations: 'Konuşma',
      sales: 'Satış',
    },
    likely: 'olası {amount}',
    empty: 'Henüz müşteri yok.',
    emptyFiltered: 'Bu filtreye uyan müşteri yok.',
    clearFilters: 'Filtreleri temizle',
  },
  profile: {
    notFound: 'Böyle bir müşteri yok.',
    backToList: 'Müşterilere dön',
    merged: 'Bu profil {name} ile birleştirildi.',
    identity: {
      title: 'Kimlik',
      name: 'Ad',
      phone: 'Telefon',
      email: 'E-posta',
      city: 'Şehir',
      username: 'Kullanıcı adı',
      addresses: 'Sohbette verilen adresler',
      edit: 'Düzenle',
      sheetTitle: 'Kimlik bilgilerini düzenle',
      save: 'Kaydet',
    },
    tags: {
      title: 'Etiketler',
      add: 'Etiket ekle',
    },
    channels: {
      title: 'Kanallar',
      seen: 'İlk: {first} · Son: {last}',
      link: 'Aynı kişi olarak bağla',
    },
    link: {
      title: 'Aynı kişi olarak bağla',
      picker: 'Bağlanacak profil',
      current: 'Bu profil',
      other: 'Bağlanacak profil',
      submit: 'Bağla',
      confirmTitle: 'Profilleri birleştir',
      confirm:
        '{other} profilinin kanalları, konuşmaları ve notları bu profile taşınır. Bu işlem geri alınamaz.',
    },
    conversations: {
      title: 'Konuşmalar',
      empty: 'Henüz konuşma yok.',
    },
    orders: {
      title: 'Siparişler ve satışlar',
      order: 'Sipariş {number}',
      staffSale: 'Personelin bildirdiği satış',
      products: { one: '{count} ürün', other: '{count} ürün' },
      openConversation: 'Konuşmayı aç',
      empty: 'Henüz sipariş veya satış yok.',
    },
    notes: {
      title: 'Notlar',
      label: 'Not',
      add: 'Not ekle',
    },
  },
} as const satisfies CatalogTree;
